import React, { useState } from "react";
import { Control } from "react-hook-form";
import { Input } from "@/components/ui/input";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Eye, EyeOff } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";
import { LoginFormData } from "./validation";

interface LoginFormFieldsProps {
  control: Control<LoginFormData>;
}

export const LoginFormFields: React.FC<LoginFormFieldsProps> = ({ control }) => {
  const [showPassword, setShowPassword] = useState(false);
  const isMobile = useIsMobile();

  return (
    <>
      <FormField
        control={control}
        name="username"
        render={({ field }) => (
          <FormItem>
            <FormLabel className={isMobile ? 'text-sm' : ''}>Gebruikersnaam</FormLabel>
            <FormControl>
              <Input 
                {...field}
                placeholder="Voer je gebruikersnaam in"
                autoComplete="username"
                className={isMobile ? 'h-10 text-base' : ''}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={control}
        name="password"
        render={({ field }) => (
          <FormItem>
            <FormLabel className={isMobile ? 'text-sm' : ''}>Wachtwoord</FormLabel>
            <FormControl>
              <div className="relative">
                <Input 
                  {...field}
                  type={showPassword ? "text" : "password"}
                  placeholder="Voer je wachtwoord in"
                  autoComplete="current-password"
                  className={`pr-10 ${isMobile ? 'h-10 text-base' : ''}`}
                />
                <button 
                  type="button"
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};